
const digest = '53f8409c459aad3adf4295660d0bdd5f22223be05983179e33c6bcafd3f545c4';
const classes = {"wrapper":"_wrapper_1ln7r_1","image":"_image_1ln7r_7","title":"_title_1ln7r_23"};
const css = `._wrapper_1ln7r_1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}
._wrapper_1ln7r_1 ._image_1ln7r_7 {
  width: 100%;
  min-height: 100px;
  font-family: Rubik, "sans-serif";
  border: 3px solid #eaedf3;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-direction: column;
  gap: 20px;
}
._wrapper_1ln7r_1 ._image_1ln7r_7 img {
  max-width: 100%;
  max-height: 100%;
}
._wrapper_1ln7r_1 ._image_1ln7r_7 ._title_1ln7r_23 {
  font-size: 14px;
  font-weight: 600;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  